export const SET_USER_INFO = 'SET_USER_INFO'
export const UNSET_USER_INFO = 'UNSET_USER_INFO'